import { RestUrl } from "../common/cyan.types";

export class OrganizationUrl {
  public static getMyOrganizations: RestUrl = ["GET", "/organizations/my"];
  public static getMyOrganizationById: (id: bigint) => RestUrl = id => ["GET", `/organizations/${id}`];
}
